// extracted by mini-css-extract-plugin
module.exports = {"jobs":"jobs___1a0sD","jobs_text":"jobs_text___XDvhb","jobs_hiring":"jobs_hiring___10J0m","jobs__description":"jobs__description___2iaBs","jobs__description__main":"jobs__description__main___3yChR","jobs__offer":"jobs__offer___2n4Em","apply__button":"apply__button___2UVYT"};
    if(module.hot) {
      // 1677682834797
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  